module.exports = __webpack_public_path__ + "static/media/nima_moving_head_head.aded0abb.png";